// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gHaM","colMin":"styles_colMin__2VlDx"};